import ExportedImage from "next-image-export-optimizer";
import Link from "next/link";
import error404 from "@/public/images/lp/404/404.svg";

export default function Custom404() {
  return (
    <>
      <div className="absolute w-full h-full overflow-hidden">
        <div className="absolute blog-ellipse-1"></div>
      </div>
      <main className="container relative mx-auto overflow-hidden font-sans text-white md:grid md:gap-0 md:grid-cols-24">
        <div className="hidden lg:block lg:col-span-2"></div>
        <div className="relative px-4 md:col-span-24 lg:col-span-20 xs:px-8 lg:px-0">
          <section className="relative flex items-center min-h-screen pt-32 pb-24 md:pt-52">
            <div className="flex flex-col items-center w-full">
              <div className="w-[250px] lg:w-[376px]">
                <svg
                  width="1032"
                  id="orbit-bg"
                  className="absolute top-1/2 3xl:top-[60%] left-1/2 -translate-x-1/2 -translate-y-1/2 3xl:scale-[130%] opacity-10 z-[-10]"
                  height="836"
                  viewBox="0 0 1032 836"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g style={{ mixBlendMode: "overlay" }}>
                    <path
                      d="M149.313 217.736C241.612 162.465 494.773 106.136 769.028 322.979C1111.85 594.034 375.426 559.669 134.417 261.716"
                      stroke="white"
                    />
                    <path
                      d="M370.281 695.108C315.01 602.809 258.681 349.648 475.524 75.392C746.579 -267.428 712.214 468.994 414.261 710.004"
                      stroke="white"
                    />
                    <path
                      d="M37.9433 509.834C86.8822 371.693 303.809 92.8238 780.006 82.4763C1375.25 69.5419 572.171 672.613 60.4782 568.941"
                      stroke="white"
                    />
                  </g>
                </svg>
                <ExportedImage
                  src={error404}
                  alt="404 page not found"
                  className="h-auto"
                />
                <h1 className="text-5xl lg:text-[80px] font-bold uppercase text-white pt-2 leading-[98.8%] lg:leading-[79px]">
                  Page not found
                </h1>
                <p className="pt-2 pb-6 text-xl font-normal">
                  Sorry, we couldn&apos;t find the page you&apos;re looking for.
                </p>
                <Link
                  href="/en/"
                  className="flex items-center justify-center  text-base font-bold text-center border-2 border-solid md:text-base  w-[230px] lg:w-[365px] h-[40px] lg:h-[50px] text-white hover:text-white hover:bg-indigo-500 rounded-[9px] back-to-homepage"
                >
                  <p>Go back to homepage</p>
                </Link>
              </div>
            </div>
          </section>
        </div>
        <div className="hidden lg:block lg:col-span-2"></div>
      </main>
    </>
  );
}
